import { Grid } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import { withRouter } from 'react-router-dom';
import { ReCAPTCHAConfig } from '../../../../config/app';
import { DataApi } from '../../../../providers/api-provider';
import { formatCurrency, Loader, postMessageToParent, showError, simpleInputStateHandlerInForm, track } from '../../libs/helpers';
import styles from '../styles/campaign-seed';
import FundStudentSeedForm from './FundStudentSeedForm';


class FundStudentSeed extends React.Component {
  constructor(props) {
    super(props);
    this.trackPageCode = 'Fund Student Donation'
    track(this.trackPageCode, 'Checkout Opened', '', true);
  }
  state = {
    dataLoading: false,
    loading: false,
    fundraise: false,
    done: false,
    recaptchaEnabled: 0,
    recaptcha: '',
    processedAmount: '',
    donationId: '',
  }
  onChange = simpleInputStateHandlerInForm
  recaptchaRef = React.createRef()

  /*
  -----------------------------------------------------------------------
  API Functions
  -----------------------------------------------------------------------
  */
  performPostSeedAction = async () => {
    const { form, donationId } = this.state
    if (form.allocateToPreferenceId === 'general')
      return postMessageToParent('hide_modal');
    this.setState({ loading: true });
    try {
      await DataApi.update('donor/fundraise-online-donations/' + donationId + '/seed-extra-info', form)
      this.setState({ loading: false });
      postMessageToParent('hide_modal');
    }
    catch (error) {
      showError(error);
      console.log(error.message);
      this.setState({ loading: false });
    };
  }
  /* API Call for fundraise data*/
  fetchData = async () => {
    this.setState({ dataLoading: true });
    try {
      let res = await DataApi.getOne('fundraises/' +
        this.props.match.params.slug + '?campaign_id=' + (this.props.match.params.campaignId || ''))
      this.setState({ dataLoading: false, fundraise: res.data });

    }
    catch (error) {
      showError(error);
      console.log(error.message);
      this.setState({ dataLoading: false });
    };
  }

  fetchRecaptchaStateData = async () => {
    try {
      let res = await DataApi.getOne('recaptcha');
      this.setState({ recaptchaEnabled: res.data });
    } catch (e) {
      this.setState({ recaptchaEnabled: true });
    }
  }
  /*
  -----------------------------------------------------------------------
  RENDER Functions
  -----------------------------------------------------------------------
  */
  async componentDidMount() {
    this.fetchData();
    this.fetchRecaptchaStateData();
  }

  onDonationComplete = (processedAmount, donationId) => {
    this.setState({ done: true, processedAmount, donationId })
  }
  onGoBackClicked() {
    postMessageToParent('hide_modal');
  }
  renderForm(classes) {
    const { fundraise, recaptcha, recaptchaEnabled } = this.state;
    let { trackPageCode, recaptchaRef, onDonationComplete } = this;
    if (!fundraise.donatable) {
      return <Typography align='center' variant="body1" style={{ width: '100%' }}>
        <Typography color='primary' inline variant="body1">{fundraise.name}</Typography> Campaign is Closed
    </Typography>
    }
    return <FundStudentSeedForm {...{
      classes, fundraise, trackPageCode, recaptcha, recaptchaRef,
      onDonationComplete, recaptchaEnabled
    }} />
  }
  renderContainer(dataLoading, fundraise, classes) {
    return dataLoading ?
      <div><Loader size='40' /></div>
      : (fundraise ? this.renderForm(classes) :
        <Typography align='center' variant="body1" style={{ width: '100%' }}>
          Oops, something went wrong, check your internet please!!
        </Typography>)
  }
  renderDone = () => {
    const { processedAmount, } = this.state;
    const { classes } = this.props;
    return (<div className={classes.doneContainer}>
      <Grid container justify="space-between">
        <Grid item xs={9}>
          <Typography variant="h4" className={classes.doneHeader}>
            THANK YOU!
          </Typography>
          <Typography variant="body1" className={classes.doneSubheader}>
            for your generous donation of <span style={{ fontWeight: 700, color: '#6A6A6A' }}>${formatCurrency(processedAmount)}</span><br />
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <img className={'fullwidth'} src={require('../../../../images/post-donation.svg')} />

        </Grid>
      </Grid>
    </div>);
  }
  /* Render Page */
  render() {
    const { classes } = this.props;
    const { recaptchaEnabled, dataLoading, fundraise, done } = this.state;
    return (
      <main className={[classes.main]}>
        <CssBaseline />
        <Paper className={classes.paper + ' seed-page-paper'} style={{ backgroundColor: '#fffffff1' }}>

          <div className={done ? 'd-none' : 'fullwidth'}>
            {this.renderContainer(dataLoading, fundraise, classes)}
          </div>
          {done && this.renderDone()}
          {recaptchaEnabled !== 0 &&
            <ReCAPTCHA
              sitekey={ReCAPTCHAConfig.site_key_invisible}
              size="invisible"
              ref={this.recaptchaRef}
            />
          }
        </Paper>
      </main>
    );
  }
}

FundStudentSeed.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(withRouter(FundStudentSeed));
